import api from './api'
export default {
    get: function(parms) {
      return api.get('chat',{
        params: parms
        })
    },
    send:function(parms) {
        return api.post('chat/send', parms);
    },
    getCommonChat:function(parms) {
      return api.get('chat/common',{
        params: parms
        })
    },
    postCommonChat:function(parms) {
      return api.post('chat/common', parms)
    },
    readChat:function(parms) {
      return api.get('chat/common/read', {
        params: parms
        })
    }
    
  }